document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('[data-cb-custom-form]');

  forms.forEach(function (wrapper) {
    const form = wrapper.querySelector('.cb-custom-form__form');
    const panels = Array.from(wrapper.querySelectorAll('.cb-custom-form__panel'));
    const steps = Array.from(wrapper.querySelectorAll('[data-step-indicator]'));
    const nextBtn = wrapper.querySelector('[data-next]');
    const prevBtn = wrapper.querySelector('[data-prev]');
    const submitBtn = wrapper.querySelector('[data-submit]');
    const errorBox = wrapper.querySelector('[data-form-error]');
    const successBox = wrapper.querySelector('[data-success]');
    const whatsappBtn = wrapper.querySelector('[data-whatsapp-btn]');
    const emailBtn = wrapper.querySelector('[data-email-btn]');

    const scriptUrl = wrapper.dataset.scriptUrl || '';
    const whatsappNumber = wrapper.dataset.whatsappNumber || '';
    const email = wrapper.dataset.email || '';
    const sourcePage = wrapper.dataset.sourcePage || window.location.pathname;

    const FILE_LIMITS = {
      maxFiles: 5,
      maxSingleBytes: 10 * 1024 * 1024,
      maxTotalBytes: 12 * 1024 * 1024,
      validExtensions: ['jpg', 'jpeg', 'png', 'webp', 'heic', 'pdf', 'doc', 'docx', 'mp4', 'mov'],
      mimeMap: {
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        webp: 'image/webp',
        heic: 'image/heic',
        pdf: 'application/pdf',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        mp4: 'video/mp4',
        mov: 'video/quicktime'
      }
    };

    let currentStep = 0;
    let pendingSubmissionId = '';

    if (!form || !panels.length || !nextBtn || !prevBtn || !submitBtn) {
      return;
    }

    function showStep(index) {
      currentStep = index;

      panels.forEach(function (panel, panelIndex) {
        panel.classList.toggle('is-active', panelIndex === index);
      });

      steps.forEach(function (step, stepIndex) {
        step.classList.toggle('is-active', stepIndex === index);
      });

      prevBtn.hidden = index === 0;
      nextBtn.hidden = index === panels.length - 1;
      submitBtn.hidden = index !== panels.length - 1;

      hideError();
    }

    function hideError() {
      if (!errorBox) return;

      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    function showError(message) {
      if (!errorBox) return;

      errorBox.hidden = false;
      errorBox.textContent = message;
    }

    function validateStep(index) {
      const fields = panels[index].querySelectorAll('input, select, textarea');

      for (const field of fields) {
        if (!field.checkValidity()) {
          field.reportValidity();
          return false;
        }
      }

      return true;
    }

    function getFieldValue(selector) {
      const field = wrapper.querySelector(selector);
      return field ? String(field.value || '').trim() : '';
    }

    function getFormPayload() {
      const fileInput = wrapper.querySelector('#cdf-upload');

      return {
        fullName: getFieldValue('#cdf-full-name'),
        email: getFieldValue('#cdf-email'),
        phone: getFieldValue('#cdf-phone'),
        city: getFieldValue('#cdf-city'),
        jewelleryType: getFieldValue('#cdf-jewellery-type'),
        metalType: getFieldValue('#cdf-metal-type'),
        stoneCategory: getFieldValue('#cdf-stone-category'),
        budget: getFieldValue('#cdf-budget'),
        referenceLink: getFieldValue('#cdf-reference-link'),
        designNotes: getFieldValue('#cdf-design-notes'),
        timeline: getFieldValue('#cdf-timeline'),
        sourcePage: sourcePage,
        files: fileInput ? Array.from(fileInput.files || []) : []
      };
    }

    function createSubmissionId() {
      const randomPart = Math.random().toString(36).slice(2, 10).toUpperCase();
      return 'CBD-' + Date.now() + '-' + randomPart;
    }

    function getExtension(fileName) {
      const segments = String(fileName || '').toLowerCase().split('.');
      return segments.length > 1 ? segments.pop() : '';
    }

    function validateFiles(files) {
      if (files.length > FILE_LIMITS.maxFiles) {
        throw new Error('You can upload a maximum of 5 files.');
      }

      let totalSize = 0;

      files.forEach(function (file) {
        const extension = getExtension(file.name);

        if (!FILE_LIMITS.validExtensions.includes(extension)) {
          throw new Error(file.name + ' is not a supported file type.');
        }

        if (file.size > FILE_LIMITS.maxSingleBytes) {
          throw new Error(file.name + ' is larger than 10 MB.');
        }

        totalSize += file.size;
      });

      if (totalSize > FILE_LIMITS.maxTotalBytes) {
        throw new Error('Total uploaded file size must be below 12 MB.');
      }
    }

    function fileToBase64(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        const extension = getExtension(file.name);

        reader.onload = function () {
          const result = String(reader.result || '');
          const base64 = result.includes(',') ? result.split(',')[1] : '';

          resolve({
            name: file.name,
            mimeType: file.type || FILE_LIMITS.mimeMap[extension] || '',
            base64: base64
          });
        };

        reader.onerror = function () {
          reject(new Error('Unable to read ' + file.name + '.'));
        };

        reader.readAsDataURL(file);
      });
    }

    async function buildPayloadWithFiles(rawData, submissionId) {
      validateFiles(rawData.files);

      const processedFiles = [];

      for (const file of rawData.files) {
        processedFiles.push(await fileToBase64(file));
      }

      return {
        submissionId: submissionId,
        submittedAt: new Date().toISOString(),
        fullName: rawData.fullName,
        email: rawData.email,
        phone: rawData.phone,
        city: rawData.city,
        jewelleryType: rawData.jewelleryType,
        metalType: rawData.metalType,
        stoneCategory: rawData.stoneCategory,
        budget: rawData.budget,
        referenceLink: rawData.referenceLink,
        designNotes: rawData.designNotes,
        timeline: rawData.timeline,
        sourcePage: rawData.sourcePage,
        files: processedFiles
      };
    }

    function delay(milliseconds) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, milliseconds);
      });
    }

    function checkSubmissionStatus(submissionId) {
      return new Promise(function (resolve, reject) {
        const callbackName = 'cbCustomFormStatus_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
        const script = document.createElement('script');
        let timeoutId;

        function cleanup() {
          if (timeoutId) {
            window.clearTimeout(timeoutId);
          }

          if (script.parentNode) {
            script.parentNode.removeChild(script);
          }

          try {
            delete window[callbackName];
          } catch (error) {
            window[callbackName] = undefined;
          }
        }

        window[callbackName] = function (response) {
          cleanup();
          resolve(Boolean(response && response.saved));
        };

        script.onerror = function () {
          cleanup();
          reject(new Error('Unable to confirm submission status.'));
        };

        const separator = scriptUrl.indexOf('?') === -1 ? '?' : '&';

        script.src =
          scriptUrl +
          separator +
          'action=status' +
          '&submissionId=' + encodeURIComponent(submissionId) +
          '&callback=' + encodeURIComponent(callbackName) +
          '&_=' + Date.now();

        timeoutId = window.setTimeout(function () {
          cleanup();
          reject(new Error('Submission confirmation timed out.'));
        }, 7000);

        document.body.appendChild(script);
      });
    }

    async function waitForSubmissionConfirmation(submissionId) {
      const maxAttempts = 12;

      for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        await delay(attempt === 0 ? 1200 : 1400);

        try {
          const saved = await checkSubmissionStatus(submissionId);

          if (saved) {
            return true;
          }
        } catch (error) {
          // Try again until the allowed confirmation time ends.
        }
      }

      return false;
    }

    function buildWhatsAppMessage(data, submissionId) {
      const lines = [
        'Hi Caratbazaar, I submitted a custom design request.',
        '',
        'Request ID: ' + submissionId,
        'Name: ' + (data.fullName || '-'),
        'Phone: ' + (data.phone || '-'),
        'Jewellery Type: ' + (data.jewelleryType || '-'),
        'Metal Type: ' + (data.metalType || '-'),
        'Stone Category: ' + (data.stoneCategory || '-'),
        'Budget: ' + (data.budget || '-'),
        'Design Notes: ' + (data.designNotes || '-')
      ];

      if (data.files && data.files.length) {
        lines.push('Reference files were uploaded with my request.');
      }

      return encodeURIComponent(lines.join('\n'));
    }

    function buildEmailBody(data, submissionId) {
      const lines = [
        'Hi Caratbazaar,',
        '',
        'I submitted a custom design request.',
        '',
        'Request ID: ' + submissionId,
        'Name: ' + (data.fullName || '-'),
        'Email: ' + (data.email || '-'),
        'Phone: ' + (data.phone || '-'),
        'City: ' + (data.city || '-'),
        'Jewellery Type: ' + (data.jewelleryType || '-'),
        'Metal Type: ' + (data.metalType || '-'),
        'Stone Category: ' + (data.stoneCategory || '-'),
        'Budget: ' + (data.budget || '-'),
        'Reference Link: ' + (data.referenceLink || '-'),
        'Design Notes: ' + (data.designNotes || '-')
      ];

      if (data.files && data.files.length) {
        lines.push('', 'Reference files were uploaded with this request.');
      }

      return encodeURIComponent(lines.join('\n'));
    }

    function showSuccess(rawData, submissionId) {
      form.hidden = true;

      if (successBox) {
        successBox.hidden = false;
      }

      if (whatsappBtn && whatsappNumber) {
        whatsappBtn.href =
          'https://wa.me/' +
          whatsappNumber +
          '?text=' +
          buildWhatsAppMessage(rawData, submissionId);
      }

      if (emailBtn && email) {
        const subject = encodeURIComponent('Custom Design Request | ' + submissionId);
        const body = buildEmailBody(rawData, submissionId);
        emailBtn.href = 'mailto:' + email + '?subject=' + subject + '&body=' + body;
      }
    }

    nextBtn.addEventListener('click', function () {
      if (!validateStep(currentStep)) return;
      showStep(currentStep + 1);
    });

    prevBtn.addEventListener('click', function () {
      showStep(currentStep - 1);
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      hideError();

      if (!validateStep(currentStep)) {
        return;
      }

      if (!scriptUrl) {
        showError('Form submission endpoint is missing.');
        return;
      }

      const rawData = getFormPayload();

      if (!pendingSubmissionId) {
        pendingSubmissionId = createSubmissionId();
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';

      try {
        const payload = await buildPayloadWithFiles(rawData, pendingSubmissionId);

        await fetch(scriptUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: JSON.stringify(payload)
        });

const successfulSubmissionId = pendingSubmissionId;
pendingSubmissionId = '';

showSuccess(rawData, successfulSubmissionId);
      } catch (error) {
        showError(error.message || 'Something went wrong. Please try again.');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit';
      }
    });

    showStep(0);
  });
});